import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import { GetTimeSlotZonesParams, GetTimeSlotZonesResponse, TimeSlotZonePayload } from './types/time-slot-zones'

type ApiGetTimeSlotZonesResponse = Promise<AxiosResponse<GetTimeSlotZonesResponse>>
type ApiCreateTimeSlotZoneResponse = Promise<AxiosResponse<void>>
type ApiUpdateTimeSlotZoneResponse = Promise<AxiosResponse<void>>
type ApiDeleteTimeSlotZoneResponse = Promise<AxiosResponse<void>>

export function getTimeSlotZones(params: GetTimeSlotZonesParams): ApiGetTimeSlotZonesResponse {
    return http.get('/dispatcher/api/time-slot-zones', { params })
}

export function createTimeSlotZone(payload: TimeSlotZonePayload): ApiCreateTimeSlotZoneResponse {
    return http.post('/dispatcher/api/time-slot-zones', payload)
}

export function updateTimeSlotZone(time_slot_zone_id: number, payload: TimeSlotZonePayload): ApiUpdateTimeSlotZoneResponse {
    return http.put(`/dispatcher/api/time-slot-zones/${time_slot_zone_id}`, payload)
}

export function deleteTimeSlotZone(time_slot_zone_id: number): ApiDeleteTimeSlotZoneResponse {
    return http.delete(`/dispatcher/api/time-slot-zones/${time_slot_zone_id}`)
}

export default {
    getTimeSlotZones,
    createTimeSlotZone,
    updateTimeSlotZone,
    deleteTimeSlotZone,
}
